export const InvoiceTerm = {
    'EXW': 'EXW',
    'C&F': 'C&F',
    'FOB': 'FOB'
}
